import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_ADDRESS_GET_BY_ID } from 'api/utilityActionTypes';

export default async function getById(
  { state, utilityApiClient },
  { addressId, forceRefresh = false },
) {
  typeCheck('addressId::Number', addressId);

  const addressStatePath = ['addresses', 'byId', addressId];
  if (state.get(addressStatePath) && !forceRefresh) {
    return state.get(addressStatePath);
  }

  return utilityApiClient.postWithState({
    action: SR_API_ACTION_ADDRESS_GET_BY_ID,
    state: state,
    payload: {
      id: addressId,
    },
    onSuccess(address) {
      state.set(addressStatePath, address);
      return address;
    },
  });
}
